import { chatTypes } from './chatTypes'

export const increaseChatMessageCounter = () => ({ type: chatTypes.ADD_CHAT_NOTIFICATION })
export const setChatMessageCounter = unreadCount => ({ type: chatTypes.SET_CHAT_NOTIFICATIONS, payload: unreadCount })
export const resetChatMessageCounter = () => ({ type: chatTypes.RESET_CHAT_NOTIFICATIONS })